<template>
  <div class="main">
    <h1>基于VUE的百度地图组件</h1>
  </div>
</template>

<script>
export default {
  name: 'main',
}
</script>

<style lang="less" scoped>
	h1{
		font-size: 24px;
		text-align: center;
		padding: 100px 0 15px;
	}
</style>



// WEBPACK FOOTER //
// main.vue?5629903e